// extracted by mini-css-extract-plugin
export var cardRadioContainer = "styles-module__cardRadioContainer___X0_z_";
export var container = "styles-module__container___f1pCk";
export var label = "styles-module__label___xZXf0";
export var radioButton = "styles-module__radioButton___ylQfl";